/**
 * Truncates `content` to at most `charLimit` characters, rolling back to the
 * last whitespace so the cut never lands in the middle of a word.
 *
 * Falls back to the raw character slice when the clipped prefix contains no
 * whitespace (e.g. a single very long token) so callers always receive a
 * string of length ≤ `charLimit`.
 */
export function truncateAtWordBoundary(content: string, charLimit: number): string {
	if (charLimit <= 0) return "";
	if (content.length <= charLimit) return content;

	const slice = content.slice(0, charLimit);
	const lastWhitespace = slice.search(/\s\S*$/);

	if (lastWhitespace <= 0) return slice;

	return slice.slice(0, lastWhitespace);
}
